import {action} from 'typesafe-actions';
import {SharedActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const unselectFleetCustomer = () =>
    action(SharedActionTypes.UNSELECT_FLEET_CUSTOMER);
export const logoutSuccess = () =>
    action(SharedActionTypes.LOGOUT_SUCCESS);
